import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,   
            cacheTime: 1000 * 60,  
            refetchOnWindowFocus: false,
        },
        mutations: {
            onError: (err) => {
            
                console.error('Mutation error', err);
            },
        },
    },
});

export default queryClient;
